import styled from '@emotion/styled';

const sizes = {
  lg: '22px',
  md: '18px',
  sm: '16px',
  xs: '14px',
};

const lineHeights = {
  lg: '32px',
  md: '24px',
  sm: '22px',
  xs: '18px',
};

const Heading = styled.h1`
  font-style: normal;
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : 'Poppins')};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 600)};
  font-size: ${(props) => (props.size ? sizes[props.size] : '22px')};
  line-height: ${(props) => (props.size ? lineHeights[props.size] : '32px')};
  color: ${(props) => (props.color ? props.color : '#212121')};
  text-align: ${(props) => (props.textAlign ? props.textAlign : 'left')};
  text-transform: ${(props) => (props.textTransform ? props.textTransform : 'auto')};
`;

export default Heading;
